import React from "react";
import { cn } from "@/lib/utils";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function SearchBar({ value, onChange, placeholder = "Search…", onSearch, className, inputClassName, ...props }) {
  return (
    <div className={cn("relative", className)}>
      <Search
        className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none"
        aria-hidden="true"
      />
      <Input
        value={value}
        onChange={onChange}
        onKeyDown={onSearch ? (e) => e.key === "Enter" && onSearch() : undefined}
        placeholder={placeholder}
        className={cn("pl-9", inputClassName)}
        {...props}
      />
    </div>
  );
}
